import OdysseyMap from './components/Map/OdysseyMap';
import JourneyFilter from './components/Sidebar/JourneyFilter';
import StatsPanel from './components/Sidebar/StatsPanel';
import LocationModal from './components/Modal/LocationModal';
import './styles/ancient-theme.css';

function App() {
  return (
    <div className="relative w-screen h-screen overflow-hidden">
      {/* Map */}
      <OdysseyMap />

      {/* Sidebars */}
      <JourneyFilter />
      <StatsPanel />

      {/* Modal */}
      <LocationModal />

      {/* Title Badge */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-[1000] bg-parchment-base border-2 border-gold rounded-lg px-6 py-3 shadow-lg">
        <h1 className="font-display text-2xl text-ink-primary text-center">
          The Odyssey Map
        </h1>
        <p className="font-ui text-sm text-center text-ink-secondary mt-1">
          Inspired by Homer's Epic & Christopher Nolan's Film
        </p>
      </div>
    </div>
  );
}

export default App;
